import { Link, NavLink, useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../lib/auth.tsx";
import { useTenant } from "../lib/tenant.tsx";

export function TopBar() {
  const { slug } = useParams<{ slug: string }>();
  const { info } = useTenant();
  const { me, logout } = useAuth();
  const nav = useNavigate();

  const onLogout = async () => {
    await logout();
    nav("/login");
  };

  return (
    <header className="topbar">
      <div className="brand">
        <Link to="/" aria-label="home" style={{ display: "flex", alignItems: "center", gap: ".75rem" }}>
          <div className="logo" />
        </Link>
        <div>
          <div className="tenant-name">{info?.tenant.name ?? slug}</div>
        </div>
        <span className="tenant-tag">ecommerce dashboard</span>
      </div>

      <nav className="mode-nav" aria-label="modos">
        <NavLink to={`/t/${slug}/strategic`}>Estratégico</NavLink>
        <NavLink to={`/t/${slug}/tactical`}>Tático</NavLink>
        <NavLink to={`/t/${slug}/operational`}>Operacional</NavLink>
      </nav>

      <div className="user">
        {me && info?.capabilities.configureIntegrations && (
          <Link to={`/t/${slug}/settings/integrations`} style={{ opacity: .8 }}>Integrações</Link>
        )}
        {me && info?.capabilities.viewAlerts && (
          <Link to={`/t/${slug}/alerts`} style={{ opacity: .8 }}>Alertas</Link>
        )}
        {me?.user.superAdmin && (
          <Link to="/admin/users" style={{ opacity: .8 }}>Usuários</Link>
        )}
        <span className="email">{me?.user.email}</span>
        <button className="btn small secondary" onClick={onLogout}
                style={{ background: "rgba(255,255,255,.1)", color: "#fff", borderColor: "rgba(255,255,255,.2)" }}>
          Sair
        </button>
      </div>
    </header>
  );
}
